import { useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";

export function KeyboardShortcuts() {
  const navigate = useNavigate();

  const handleKey = useCallback(
    (e: KeyboardEvent) => {
      const target = e.target as HTMLElement;
      const inInput =
        target.tagName === "INPUT" ||
        target.tagName === "TEXTAREA" ||
        target.isContentEditable;

      if (e.key === "/" && !inInput) {
        e.preventDefault();
        document.querySelector<HTMLInputElement>('input[type="text"]')?.focus();
      }
      if (e.key === "?" && !inInput) {
        navigate("/syntax-help");
      }
      if (e.key === "Escape") {
        document.querySelector<HTMLInputElement>('input[type="text"]')?.blur();
      }
    },
    [navigate]
  );

  useEffect(() => {
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [handleKey]);

  return null;
}
